<template>
  <div>
    <div class="row justify-content-end align-items-end">
      <div class="col"></div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'seller-customers-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau client vendeur
        </button>
      </div>
    </div>
    <br />
    <vue-data-table
      :headers="headers"
      :data="sellerCustomers"
      :buttons="buttons"
      :items-per-page="10"
    >
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        { label: "Référence", field: "reference", class: "text-center" },
        { label: "Nom Complet", field: "fullName", class: "text-left" },
        { label: "Prénom", field: "firstName", class: "text-left" },
        { label: "Nom", field: "lastName", class: "text-left" },
        { label: "Téléphone", field: "phone", class: "text-right" },
        { label: "Email", field: "email", class: "text-left" },
        {
          label: "Référence Vendeur",
          field: "seller_reference",
          class: "text-left",
        },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn-info",
          action: (row) =>
            this.$router.push({
              name: "seller-customers-details",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Edit",
          icon: "bi bi-pencil",
          class: "btn-primary",
          action: (row) =>
            this.$router.push({
              name: "seller-customers-edit",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("sellerCustomer", {
      sellerCustomers: "getSellerCustomers",
    }),
  },
  mounted() {
    this.$store.dispatch("sellerCustomer/getAll");
  },
  methods: {
    async remove(reference) {
      await this.$store.dispatch("sellerCustomer/destroy", reference);
    },
    async refresh() {
      await this.$store.dispatch("sellerCustomer/getAll");
    },
  },
};
</script>
